/*@ngInject*/
const ProductTemplateEditorRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadProductTemplateById = function (productTemplateId) {
        var url = '/rest/ProductTemplate/' + productTemplateId;
        return this.get(url);
    };

    this.createProductTemplate = function (productTemplate) {
        var url = '/rest/ProductTemplate';
        return this.post(url, productTemplate);
    };

    this.updateProductTemplate = function (productTemplate) {
        var url = '/rest/ProductTemplate/' + productTemplate.id;
        return this.post(url, productTemplate);
    };

    this.updateDocumentTemplates = function (productTemplate, quoteFile, binderFile) {
        var url = '/rest/ProductTemplate/' + productTemplate.id + '/documentTemplates',
            formData = new FormData(),
            config = {
                transformRequest: angular.identity,
                // When you assign undefined, the content type defaults to multipart/form-data
                headers: {
                    'Content-Type': undefined
                },
                params: {
                    quoteFileTemplateId: productTemplate.quoteFileTemplateId,
                    binderFileTemplateId : productTemplate.binderFileTemplateId
                }
            };

        formData.append('quoteFile', quoteFile);
        formData.append('binderFile', binderFile);
        return this.post(url, formData, config);
    };


};

angular.module('ums.configuration')
    .service('productTemplateEditorRepository', ProductTemplateEditorRepository);
